import { object, string } from 'yup';

export default object({
  deviceType: string()
    .oneOf(['usbc', 'lightning'])
    .required('Please select your iQ device before continuing to checkout.'),
});
